import { cache, get } from "@/api/common";
import { showConfirmDialog } from "vant";
export default {
  name: 'App',
  components: {},
  data() {
    return {
      active: 0,
      show: true,
      showLoading: false,
      showDialog: false,
      showDialogStr: '绑定微信公众号即送500积分，获取实时信息，回家不迷路~~~',
      showGroupDialog: false,
      showGroupDialogStr: '加入微信群即送500积分，获取实时信息，回家不迷路~~~',
      menus: [{
        to: '/home',
        icon: 'home-o',
        text: '首页'
      },
      // {to: '/movie', icon: 'cart-o', text: '影院'},
      {
        to: '/credit',
        icon: 'cart-o',
        text: '积分商城'
      }, {
        to: '/read',
        icon: 'bookmark-o',
        text: '公告(送积分)'
      }, {
        to: '/center',
        icon: 'friends-o',
        text: '我的'
      }]
    };
  },
  mounted() {
    var that = this;
    window.VuePageApp = that;
    // that.showDialog=true
    // window.Xxxxxx = that
    get('app/user/info').then(res => {
      if (res.status != 0) {
        return;
      }
      cache("info", res.result);
      window.Weixin.create({
        name: "中广雅涵优品",
        id: res.result.id,
        desc: "看电影，买奶茶选择中广雅涵优品"
      });
      setTimeout(function () {
        let islink = that.$route.query.is_link_wx;
        let is_link_group = that.$route.query.is_link_group;
        //清理参数is_link_wx
        let query = that.$route.query;
        delete query.is_link_wx;
        delete query.is_link_group;
        query = JSON.parse(JSON.stringify(query));
        query.is_run = 1;
        that.$router.replace({
          path: that.$route.path + '',
          query: query
        });
        if (res.result.is_link_wx != 1) {
          if (islink == 1) {
            get("app/user/setLinkWx", {});
            return;
          }
          //判断是否是第一次登录
          var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 && isMobile) {
            showConfirmDialog({
              message: '绑定微信公众号即送500积分，获取实时信息，回家不迷路~~~'
            }).then(() => {
              // on close
              location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzNzcwNzYzMg==#wechat_redirect";
            });
          } else {
            that.showDialogStr = '绑定微信公众号即送500积分，获取实时信息，回家不迷路~~~';
            that.showDialog = true;
          }
          return;
        }
        if (res.result.is_link_group == 1) {
          return;
        }
        if (is_link_group == 1) {
          get("app/user/setLinkGroup", {});
          return;
        }
        //如果没有关注微信群
        // that.showGroupDialogStr = '加入微信群即送500积分，获取实时信息，回家不迷路~~~'
        // that.showGroupDialog = true
        // }

        showConfirmDialog({
          title: '',
          message: '加入微信群即送500积分，获取实时信息，回家不迷路~~~'
        }).then(() => {
          // on confirm
          location.href = "https://work.weixin.qq.com/gm/1a9899d51186d8ab9d4540b4436a6781";
        }).catch(() => {
          // on cancel
        });
      }, 100);
    });
  },
  watch: {
    "$route.query": {
      immediate: true,
      // 第一次的数据，也要当做是一种变化
      // 处理函数（不能修改名字） handler('新的值'，'旧的值')
      handler() {
        // 执行代码部分
        this.show = false;
        // console.log(this.$route.path)
        if (this.$route.path == '/') {
          this.show = true;
          return;
        }
        for (var i = 0; i < this.menus.length; i++) {
          if (this.menus[i].to == this.$route.path) {
            this.show = true;
            break;
          }
        }
      }
    }
  }
};